import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface DeliveryCharges {
    area_code_name: any;
    description: any;
    delivery_charge: any;
    discount_type: any;
}
type DeliveryChargesResponse = {
    data: {
        data: DeliveryCharges[];
        count: number;
        status: string;
        payload?: any;
    };
    isSuccess: boolean;
    status: number;
};

interface DeliveryChargesState {
    data: DeliveryCharges[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

export const fetchDeliveryCharges = createAsyncThunk<
    DeliveryCharges[],
    void,
    { rejectValue: string }
>(
    'DeliveryCharges/fetchDeliveryCharges',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<DeliveryChargesResponse>(
                '/get_all_delivery_charges',
                PORT,
                URL
            );

            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred'
            );
        }
    }
);


export const createDeliveryCharges = createAsyncThunk<DeliveryCharges, any, { rejectValue: string }>(
    'DeliveryCharges/createDeliveryCharges',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: DeliveryCharges }>('create_delivery_charge', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateDeliveryCharges = createAsyncThunk<DeliveryCharges, any, { rejectValue: string }>(
    'DeliveryCharges/updateDeliveryCharges',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: DeliveryCharges }>('update_delivery_charge', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const softDeleteDeliveryCharges: any = createAsyncThunk<
    number,
    number
>(
    "DeliveryCharges/softDeleteDeliveryCharges",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `delete_delivery_charge?id=${id}`,
                {},
               PORT, URL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting Delivery Charges"
            );
        }
    }
);
export const DeliveryChargesSlice = createSlice({
    name: 'DeliveryCharges',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as DeliveryChargesState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDeliveryCharges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDeliveryCharges.fulfilled, (state, action: PayloadAction<DeliveryCharges[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDeliveryCharges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createDeliveryCharges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createDeliveryCharges.fulfilled, (state, action: PayloadAction<DeliveryCharges>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createDeliveryCharges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateDeliveryCharges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDeliveryCharges.fulfilled, (state, action: PayloadAction<DeliveryCharges>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateDeliveryCharges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
           
    },
});

export default DeliveryChargesSlice.reducer;